module.exports = __webpack_public_path__ + "img/title_8.56c8702f.png";